// Generated by scripts/generate-help.mjs from the Markdown topics in OAA-BI-FE/Help.
// Do not edit: change the Markdown and run `npm run generate:help`.

/** Titles by `section/topic` key (`''` is the Help home), for document titles before the content loads. */
export const HELP_TITLES: Readonly<Record<string, string>> = {
  '': 'Help',
  screens: 'Screens',
  'screens/navigation': 'Navigation and sidebar',
  'screens/global-filters': 'Global filters',
  'screens/account-details': 'Account details',
  'screens/data-freshness': 'Data freshness',
  'screens/sign-in': 'Signing in and sessions',
  'screens/overview': 'Overview',
  'screens/revenue': 'Revenue',
  'screens/subscriptions': 'Subscriptions',
  'screens/renewals': 'Renewals',
  'screens/product-offers': 'Product offers',
  'screens/users': 'Users',
  'screens/apps': 'Apps',
  'screens/cohorts': 'Cohorts',
  'screens/totals': 'Totals',
  'screens/trends': 'Trends',
  'screens/subscription-reports': 'Subscription reports',
  'screens/saved-views': 'Saved views and Customize',
  'screens/data-explorer': 'Data explorer',
  'screens/profile': 'Profile',
  'screens/record-pages': 'Record pages',
  'screens/conversion': 'Conversion',
  'screens/trials': 'Trials',
  'screens/markets': 'Markets',
  'screens/leads': 'Leads',
  kpis: 'KPIs',
  'kpis/mrr': 'MRR',
  'kpis/arr': 'ARR',
  'kpis/arpa': 'ARPA',
  'kpis/net-new-mrr': 'Net new MRR',
  'kpis/mrr-growth': 'MRR growth rate',
  'kpis/new-mrr': 'New MRR',
  'kpis/expansion-mrr': 'Expansion MRR',
  'kpis/contraction-mrr': 'Contraction MRR',
  'kpis/churned-mrr': 'Churned MRR',
  'kpis/quick-ratio': 'Quick ratio',
  'kpis/billing-mix': 'Billing mix',
  'kpis/paying-subscriptions': 'Paying subscriptions',
  'kpis/new-subscriptions': 'New subscriptions',
  'kpis/lost-subscriptions': 'Lost subscriptions',
  'kpis/lifecycle-counts': 'Lifecycle today',
  'kpis/recoverable-mrr': 'Recoverable MRR',
  'kpis/net-revenue-retention': 'Net revenue retention',
  'kpis/logo-churn': 'Logo churn',
  'kpis/gross-revenue-churn': 'Gross revenue churn',
  'kpis/cohort-revenue-retention': 'Cohort revenue retention',
  'kpis/cohort-logo-retention': 'Cohort logo retention',
  'kpis/renewal-value': 'Renewal value',
  'kpis/renewals-due-90-days': 'Renewals due in 90 days',
  'kpis/renewals-at-risk': 'Renewals at risk',
  'kpis/renewals-due-12-months': 'Renewals due in 12 months',
  'kpis/billed-monthly': 'Billed monthly',
  'kpis/offer-subscriptions-and-share': 'Offer subscriptions, MRR and share',
  'kpis/offer-new-in-period': 'New in period by offer',
  'kpis/offer-retention': 'Offer NRR and logo churn',
  'kpis/add-on-share': 'Add-on share',
  'kpis/add-on-attach-rate': 'Add-on attach rate',
  'kpis/average-users': 'Average users per subscription',
  'kpis/offer-price': 'Offer price',
  'kpis/offer-kind': 'Standard, custom and archived offers',
  'kpis/list-mrr': 'List MRR',
  'kpis/trials-started': 'Trials started',
  'kpis/trial-conversion': 'Trial conversion',
  'kpis/expired-trials': 'Expired trials',
  'kpis/running-trials': 'Running trials',
  'kpis/users-on-paying-subscriptions': 'Users on paying subscriptions',
  'kpis/active-users': 'Active users',
  'kpis/invited-not-joined': 'Invited, not joined',
  'kpis/owners-and-admins': 'Owners and admins',
  'kpis/users-added-30-days': 'Users added in 30 days',
  'kpis/active-user-share': 'Active user share',
  'kpis/at-user-limit': 'At user limit',
  'kpis/total-apps': 'Apps',
  'kpis/published-apps': 'Published apps',
  'kpis/published-in-period': 'Published in period',
  'kpis/public-apps': 'Public apps',
  'kpis/connected-apps': 'Connected to databases or APIs',
  'kpis/apps-created-30-days': 'Apps created in 30 days',
  'kpis/apps-by-data-source': 'Apps by data source',
  'kpis/active-apps': 'Active apps · 30 days',
  'kpis/app-opens': 'App opens and sessions · 30 days',
  'kpis/published-apps-not-used': 'Published apps not used · 30 days',
  'kpis/app-opens-per-month': 'App opens per month',
  'kpis/checkout-visitors': 'Checkout visitors',
  'kpis/buyers': 'Buyers',
  'kpis/checkout-conversion': 'Checkout conversion',
  'kpis/abandoned-checkouts': 'Abandoned checkouts',
  'kpis/new-paying-customers': 'New paying customers',
  'kpis/time-to-buy': 'Time to buy',
  'kpis/payments-received': 'Payments received',
  'kpis/paying-customers-by-market': 'Paying customers by market',
  'kpis/largest-market': 'Largest market',
  'kpis/lead-intent-score': 'Lead intent score',
  'kpis/discount-share': 'Discount share of gross billings',
  'kpis/discounts-given': 'Discounts given',
  'kpis/discounted-vs-full-price': 'Discounted vs full-price subscriptions',
  'kpis/coupon-redemptions': 'Coupon and promotion code redemptions',
  'kpis/row-totals': 'Row totals',
  'kpis/payments-collected': 'Payments collected',
  'kpis/failed-payment-attempts': 'Failed payment attempts',
  'kpis/refunded': 'Refunded',
  'kpis/disputes': 'Disputes',
  'kpis/paid-out': 'Paid out',
  'data-model': 'Data model',
  'data-model/account': 'Account',
  'data-model/trial': 'Trial',
  'data-model/monthly-mrr': 'Monthly MRR',
  'data-model/mrr-movement': 'MRR movement',
  'data-model/lifecycle-state': 'Lifecycle state',
  'data-model/offer-and-billing': 'Offer and billing type',
  'data-model/add-on': 'Add-on (additional user seat)',
  'data-model/team': 'Team',
  'data-model/user': 'User',
  'data-model/app': 'App',
  'data-model/renewal': 'Renewal',
  'data-model/cohort': 'Cohort',
  'data-model/period': 'Reporting period',
  'data-model/saved-view': 'Saved view',
  'data-model/license': 'License',
  'data-model/checkout-session': 'Checkout session',
  'data-model/payment': 'Payment',
  'data-model/lead': 'Lead',
  'data-model/discount': 'Discount, coupon and promotion code',
  'data-model/api-teams': 'api.Teams',
  'data-model/api-team-members': 'api.TeamMembers',
  'data-model/api-apps': 'api.Apps',
  'data-model/api-creators': 'api.Creators',
  'data-model/api-subscriptions': 'api.Subscriptions',
  'data-model/api-active-subscriptions': 'api.ActiveSubscriptions',
  'data-model/api-team-features': 'api.TeamFeatures',
  'data-model/api-app-edits': 'api.AppEdits',
  'data-model/api-app-invitations': 'api.AppInvitations',
  'data-model/api-hubs': 'api.Hubs',
  'data-model/api-hub-apps': 'api.HubApps',
  'data-model/dbo-users': 'dbo.Users',
  'data-model/dbo-teams': 'dbo.Teams',
  'data-model/dbo-team-users': 'dbo.TeamUsers',
  'data-model/dbo-subscriptions': 'dbo.Subscriptions',
  'data-model/dbo-subscription-plans': 'dbo.SubscriptionPlans',
  'data-model/dbo-resources': 'dbo.Resources',
  'data-model/stripe-customers': 'stripe.Customers',
  'data-model/stripe-subscriptions': 'stripe.Subscriptions',
  'data-model/stripe-subscription-items': 'stripe.SubscriptionItems',
  'data-model/stripe-prices': 'stripe.Prices',
  'data-model/stripe-products': 'stripe.Products',
  'data-model/stripe-invoices': 'stripe.Invoices',
  'data-model/stripe-invoice-lines': 'stripe.InvoiceLines',
  'data-model/stripe-invoice-custom-fields': 'stripe.InvoiceCustomFields',
  'data-model/stripe-coupons': 'stripe.Coupons',
  'data-model/stripe-discounts': 'stripe.Discounts',
  'data-model/stripe-tax-rates': 'stripe.TaxRates',
  'data-model/stripe-payment-intents': 'stripe.PaymentIntents',
  'data-model/stripe-charges': 'stripe.Charges',
  'data-model/stripe-refunds': 'stripe.Refunds',
  'data-model/stripe-disputes': 'stripe.Disputes',
  'data-model/stripe-balance-transactions': 'stripe.BalanceTransactions',
  'data-model/stripe-payouts': 'stripe.Payouts',
  'data-model/stripe-events': 'stripe.Events',
  'data-model/stripe-objects': 'stripe.Objects',
  'data-model/dbo-app-usage': 'dbo.AppUsage',
  'data-model/dbo-native-usage-last30-days': 'dbo.NativeUsageLast30Days',
  'data-model/dbo-web-client-usage-30-days': 'dbo.WebClientUsage_30Days',
  'data-model/dbo-web-client-usage-total': 'dbo.WebClientUsage_Total',
  'data-model/dbo-app-sizes': 'dbo.AppSizes',
  'data-model/dbo-app-features': 'dbo.AppFeatures',
  'data-model/biapp-users': 'biapp.Users',
  'data-model/biapp-user-credentials': 'biapp.UserCredentials',
  'data-model/bi-app-event': 'bi.AppEvent',
  'data-model/bi-event-type': 'bi.EventType',
  'data-model/bi-app-usage-daily': 'bi.AppUsageDaily',
  'data-model/bi-app-usage-monthly': 'bi.AppUsageMonthly',
  'data-model/bi-preview-interaction-daily': 'bi.PreviewInteractionDaily',
  'data-model/bi-app-catalog': 'bi.AppCatalog',
  'data-model/bi-vw-app-event': 'bi.vw_AppEvent',
  'data-model/bi-vw-app-usage-daily': 'bi.vw_AppUsageDaily',
  'data-model/bi-vw-app-usage-monthly': 'bi.vw_AppUsageMonthly',
  'data-model/bi-vw-preview-interaction-daily': 'bi.vw_PreviewInteractionDaily',
  'data-model/etl-source': 'etl.Source',
  'data-model/etl-watermark': 'etl.Watermark',
  'data-model/etl-run-log': 'etl.RunLog',
  'data-model/etl-dirty-day': 'etl.DirtyDay',
  'data-model/etl-event-category-rule': 'etl.EventCategoryRule',
  'data-model/etl-vw-load-status': 'etl.vw_LoadStatus',
  ai: 'AI',
  'ai/access-and-data-protection': 'Access and data protection',
  'ai/portal-api': 'Portal API',
  'ai/sql-mcp-server': 'SQL MCP Server',
  'ai/vs-code-copilot': 'VS Code and GitHub Copilot',
  'ai/context-for-ai': 'Briefing for the AI',
  'ai/example-questions': 'Example questions and checking answers',
  metamodel: 'Metamodel',
};
